import dynamic from "next/dynamic";

import type { Props as AdSlotProps } from "~/components/advertisement/ad-slots/ad-slot";
import type { Props as HeaderProps } from "~/components/header";
import type { Props as PostiesBrochureHeaderProps } from "~/components/posties/header/posties-brochure-header";
import type { Props as PostiesContentHeaderProps } from "~/components/posties/header/posties-content-header";

export const DynamicAdSlot = dynamic<AdSlotProps>(() =>
  import("~/components/advertisement/ad-slots/ad-slot").then(module => module.AdSlot),
);

export const DynamicStyleContentHeader = dynamic<HeaderProps>(() =>
  import("~/components/section/section-style/section-style-header").then(
    module => module.StyleContentHeader,
  ),
);

export const DynamicPostiesBrochureHeader = dynamic<PostiesBrochureHeaderProps>(() =>
  import("~/components/posties/header/posties-brochure-header").then(
    module => module.PostiesBrochureHeader,
  ),
);

export const DynamicPostiesContentHeader = dynamic<PostiesContentHeaderProps>(() =>
  import("~/components/posties/header/posties-content-header").then(
    module => module.PostiesContentHeader,
  ),
);

export const DynamicHeader = dynamic<HeaderProps>(() =>
  import("~/components/header").then(module => module.Header),
);
